// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconInputAngleDown: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="9" viewBox="0 0 15 9" fill="currentColor">
            <path
                d="M6.6015625,0.361607143 C7.109375,-0.120535714 7.890625,-0.120535714 8.3984375,0.361607143 L14.6484375,6.79017857 C15.1171875,7.3125 15.1171875,8.11607143 14.6484375,8.63839286 C14.140625,9.12053571 13.359375,9.12053571 12.8515625,8.63839286 L7.5,3.09375 L2.1484375,8.63839286 C1.640625,9.12053571 0.859375,9.12053571 0.3515625,8.63839286 C-0.1171875,8.11607143 -0.1171875,7.3125 0.3515625,6.79017857 L6.6015625,0.361607143 Z"
                transform="matrix(1 0 0 -1 0 9)"
            />
        </svg>
    );
};

export default React.memo(IconInputAngleDown);
